import React from 'react';
import { Link } from 'react-router-dom';

import { TableActions } from 'components/Table/TableActions';
import i18n from 'translations';
import { IParts } from 'thunks/RTKQuery/parts';

export interface IActionsProps {
  parts: IParts;
  showActions: boolean;
  onRedo: (ticket: IParts) => void;
}

export const Actions = ({ parts, showActions, onRedo }: IActionsProps) => {
  return (
    <div className="visible-actions">
      <TableActions>
        {showActions && parts.isLocked && (
          <>
            <Link
              data-cy="redo-user-action"
              to="#"
              onClick={() => onRedo(parts)}
            >
              {i18n.t('partsView.actions.redo')}
            </Link>
          </>
        )}
      </TableActions>
    </div>
  );
};
